import React, {useEffect} from 'react';
import {useFormik} from 'formik';
import {useIsAuthenticated, useSignOut} from "react-auth-kit";
import {requestApi, showAlertAutoDis, validateUser} from "../../utils/utils";
import PrimaryButton from "../../components/Common/PrimaryButton";

const ForgotPasswordPage = ({history}) => {
    const isAuthenticated = useIsAuthenticated();
    const signOut = useSignOut();

    useEffect(() => {
        verifyAuth().catch();
    }, []);

    const verifyAuth = async () => {
        if (isAuthenticated()) {
            const data = await validateUser();
            if (data.status === 'success' && !data.validate)
                return signOut();
            history.push(`/booking/my-bookings`);
        }
    }


    const formik = useFormik({
        initialValues: {
            email: '',
        },
        onSubmit: async (values) => {
            try {
                const {data} = await requestApi('/customer/password/email', 'POST', values);

                if (data.status === 'success') {
                    showAlertAutoDis({title: 'Success', text: data.message}, () => {
                        history.push('/booking/login');
                    });
                } else {
                    showAlertAutoDis({title: 'Error', text: data.message});
                }
            } catch (data) {
                const {title, message: text} = data;
                showAlertAutoDis({title, text});
            }
        },
    });

    return (
        <div className="wrapper" style={{paddingTop: 50}}>
            <div className="auth_pages nautilus-login">
                <h1>Forgot Password</h1>
                <p className="text-left">
                    It happens to the best of us. Enter your email below and we will send you a reset link.
                </p>
                <form onSubmit={formik.handleSubmit}>
                    <div className="login-container">
                        <div className="col-100 text-left">
                            <label htmlFor="email">Email Address</label>
                            <input type="text" onChange={formik.handleChange}
                                   value={formik.values.email} name="email" id="email"
                                   placeholder="Email"/>
                        </div>

                        <div className="spacer"/>

                        <div className="submit">
                            <input style={{padding: '8px 30px', letterSpacing: '0.1em', fontWeight: '600'}}
                                   type="submit" name="submit" value="Reset Password" className="gold-button"/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;